import { ArrowLeft } from 'lucide-react';
import { useBack, type UseBackOptions } from './useBack';

interface Props extends UseBackOptions {
  /** icon = nur Pfeil (Dokumentkopf), text = Pfeil mit „Zurück zu …" */
  variant?: 'icon' | 'text';
  className?: string;
}

/** Zurück-Link im Dokumentkopf (Regel „Dokument-Navigation" R2). */
export function BackLink({ variant = 'icon', className = '', ...opts }: Props) {
  const back = useBack(opts);
  if (variant === 'text') {
    return (
      <button
        type="button"
        onClick={back.go}
        data-test-anchor="back"
        className={`inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200 min-h-[44px] -ml-2 px-2 ${className}`}
      >
        <ArrowLeft size={18} className="flex-shrink-0" />
        <span className="truncate">{back.label}</span>
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={back.go}
      data-test-anchor="back"
      aria-label={back.label}
      title={back.label}
      className={`text-slate-400 hover:text-slate-200 -ml-2 p-2 flex-shrink-0 min-h-[44px] min-w-[44px] flex items-center justify-center ${className}`}
    >
      <ArrowLeft size={20} />
    </button>
  );
}
